import { render, staticRenderFns } from "./SelectedIcon.vue?vue&type=template&id=da708a64&"
import script from "./SelectedIcon.vue?vue&type=script&lang=js&"
export * from "./SelectedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports